import { c as _c } from "react/compiler-runtime";
import classNames from 'classnames';
import { useViewport } from '@sbt-web/hooks';
import { wholeNumberDigit } from '@sbt-web/utils';
import ownClasses from './AdsCount.module.scss';
const AdsCount = t0 => {
  const $ = _c(9);
  const {
    children: total
  } = t0;
  const {
    isMobile
  } = useViewport();
  const t1 = !isMobile;
  const t2 = !isMobile;
  let t3;
  if ($[0] !== isMobile || $[1] !== t1 || $[2] !== t2) {
    t3 = classNames("caption", "total-ads", ownClasses["total-ads"], {
      book: isMobile,
      small: isMobile,
      semibold: t1,
      normal: t2
    });
    $[0] = isMobile;
    $[1] = t1;
    $[2] = t2;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== total) {
    t4 = wholeNumberDigit.format(total);
    $[4] = total;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  const t5 = `${t4} risultat${total === 1 ? "o" : "i"}`;
  let t6;
  if ($[6] !== t3 || $[7] !== t5) {
    t6 = <p className={t3}>{t5}</p>;
    $[6] = t3;
    $[7] = t5;
    $[8] = t6;
  } else {
    t6 = $[8];
  }
  return t6;
};
export default AdsCount;